import type { IMaskFunction } from 'interfaces/IMask';

const numberandzero: IMaskFunction = {
  apply: (value: string) => {
    if (!value) return '';

    const regexp = /^(\d{0,20}).*/;
    const result = '$1';

    return value
      .toString()
      .replace(regexp, result)
      .replace(/[-.\\]$/, '')
      .replace(/[-.\\]$/, '')
      .replace(/[-.\\]$/, '');
  },
  clean: (value: string): string => {
    if (!value) {
      return '';
    }

    return value.replace(/\D/g, '');
  }
};

export default numberandzero;
